export const ACHIEVEMENT_EVENT_LIST_REQUEST = "ACHIEVEMENT_EVENT_LIST_REQUEST"
export const ACHIEVEMENT_EVENT_LIST_SUCCESS = "ACHIEVEMENT_EVENT_LIST_SUCCESS"
export const ACHIEVEMENT_EVENT_LIST_ALL_SUCCESS = "ACHIEVEMENT_EVENT_LIST_ALL_SUCCESS"
export const ACHIEVEMENT_EVENT_LIST_FAIL = "ACHIEVEMENT_EVENT_LIST_FAIL"

export const ACHIEVEMENT_CATEGORY_LIST_REQUEST = "ACHIEVEMENT_CATEGORY_LIST_REQUEST"
export const ACHIEVEMENT_CATEGORY_LIST_SUCCESS = "ACHIEVEMENT_CATEGORY_LIST_SUCCESS"
export const ACHIEVEMENT_CATEGORY_LIST_FAIL = "ACHIEVEMENT_CATEGORY_LIST_FAIL"